// Copyright (c) Ping. All rights reserved.

import type React from 'react';
import { StyleSheet, Text, type TextStyle, View, type ViewStyle } from 'react-native';
import { createTheme } from '../design-system/theme';
import { useColorScheme } from '../foundations/colorScheme';
import { callHistoryStrings } from './strings';
import type { CallHistoryFilter } from './types';

export interface CallHistoryEmptyStateProps {
  readonly filter: CallHistoryFilter;
  readonly query: string;
}

export const CallHistoryEmptyState: React.FC<CallHistoryEmptyStateProps> = ({ filter, query }) => {
  const scheme = useColorScheme();
  const theme = createTheme(scheme);
  const hasQuery = query.trim().length > 0;

  return (
    <View style={styles.wrap} accessibilityRole="summary">
      <Text style={[styles.title, { color: theme.colors.text.primary }]}>
        {callHistoryStrings.emptyTitle(filter, hasQuery)}
      </Text>
      <Text style={[styles.body, { color: theme.colors.text.secondary }]}>
        {callHistoryStrings.emptyBody}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 32,
    gap: 8,
  } satisfies ViewStyle,
  title: {
    fontSize: 17,
    fontWeight: '600',
    textAlign: 'center',
  } satisfies TextStyle,
  body: {
    fontSize: 14,
    textAlign: 'center',
    maxWidth: 280,
  } satisfies TextStyle,
});
